import { useGetPermission } from 'hooks/business/useNewPermisson';

/**
 * 退款抽屉相关权限：敏感信息展示、弃单操作权限。
 * 单一职责：仅负责权限布尔值，不参与 UI 或业务动作。
 */
export function useRefundDrawerPermissions() {
  const getPermission = useGetPermission();
  const displaySensitive = getPermission('订单敏感信息');
  const operatable = getPermission('操作弃单');

  return { displaySensitive, operatable };
}
